module.exports = __webpack_public_path__ + "1831c2aa8be8236ea5950eb7c359caa5.svg";